module.exports = __webpack_public_path__ + "img/38_44.0889830a.png";